// StatusPopup.jsx
import React from 'react';

// Desired display order (IDs only – no change to underlying values)
const CUSTOM_ORDER = [1, 2, 4, 5, 3];

// Full status data for each ID (used as fallback if no external statuses are provided)
const DEFAULT_STATUSES_MAP = {
  1: { id: 1, name: "To Do", icon: "fa-circle", color: "#6c757d", bgColor: "#e9ecef" },
  2: { id: 2, name: "In Progress", icon: "fa-spinner", color: "#fd7e14", bgColor: "#fff3e0" },
  3: { id: 3, name: "Archived", icon: "fa-archive", color: "#6c757d", bgColor: "#e9ecef" },
  4: { id: 4, name: "Blocked", icon: "fa-times", color: "#dc3545", bgColor: "#f8d7da" },
  5: { id: 5, name: "Done", icon: "fa-check-circle", color: "#28a745", bgColor: "#d4edda" },
};

// Reorder any status array according to CUSTOM_ORDER
const reorderStatuses = (statusesArray) => {
  if (!statusesArray || statusesArray.length === 0) return [];
  const statusMap = new Map(statusesArray.map(s => [s.id, s]));
  return CUSTOM_ORDER.map(id => statusMap.get(id)).filter(Boolean);
};

const StatusPopup = ({ statuses, selectedStatus, onSelect }) => {
  // Determine which status list to display (external or default)
  let effectiveStatuses;
  if (statuses?.length) {
    // External statuses – reorder them for display only
    effectiveStatuses = reorderStatuses(statuses);
  } else {
    // No external statuses – use default map in custom order
    effectiveStatuses = CUSTOM_ORDER.map(id => DEFAULT_STATUSES_MAP[id]);
  }

  return (
    <div>
      <div style={{ padding: '12px', borderBottom: '1px solid #eee', fontWeight: 'bold' }}>
        Select Status
      </div>
      <div>
        {effectiveStatuses.map(status => (
          <div
            key={status.id}
            onClick={() => onSelect(status)}
            style={{
              padding: '10px 12px',
              cursor: 'pointer',
              backgroundColor: selectedStatus?.id === status.id ? '#f8f9fa' : 'transparent',
              borderBottom: '1px solid #f5f5f5',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              borderLeft: selectedStatus?.id === status.id ? `3px solid ${status.color}` : '3px solid transparent',
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f5f5f5'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 
              selectedStatus?.id === status.id ? '#f8f9fa' : 'transparent'}
          >
            <div style={{
              width: '20px', height: '20px', borderRadius: '4px',
              backgroundColor: status.bgColor, color: status.color,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '10px', flexShrink: 0,
            }}>
              <i className={`fas ${status.icon}`} />
            </div>
            <span style={{ flex: 1 }}>{status.name}</span>
            {selectedStatus?.id === status.id && (
              <i className="fas fa-check" style={{ marginLeft: 'auto', color: status.color }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusPopup;